{
  "$id": "module://bank-account",
  "$schema": "wealthlane://schemas/domain",
  "title": "Bank Account",
  "description": "Company bank account field catalog",
  "type": "object",
  "properties": {
    "accountName": {
      "type": "string",
      "title": "Account Holder Name",
      "noBlank": true,
      "maxLength": 200
    },
    "accountNickName": {
      "type": "string",
      "title": "Account Nick Name",
      "noBlank": true,
      "maxLength": 200
    },
    "routingTypeId": {
      "type": "string",
      "title": "Routing Type",
      "widget": "select"
    },
    "routingNumber": {
      "type": "string",
      "title": "Routing Number",
      "noBlank": true,
      "maxLength": 50
    },
    "accountTypeId": {
      "type": "string",
      "title": "Account Type",
      "widget": "select"
    },
    "accountNumber": {
      "type": "string",
      "title": "Account Number",
      "noBlank": true,
      "maxLength": 50
    },
    "institutionName": {
      "type": "string",
      "title": "Institution Name",
      "noBlank": true,
      "maxLength": 200
    },
    "verificationType": {
      "type": "string",
      "title": "Verification Type"
    },
    "routingType": {
      "type": "string",
      "title": "Routing Type"
    },
    "accountType": {
      "type": "string",
      "title": "Account Type"
    },
    "status": {
      "type": "string",
      "title": "Status"
    }
  }
}
